__turbopack_context__.v({
  "body": "wNpI9W_body",
  "closeButton": "wNpI9W_closeButton",
  "footer": "wNpI9W_footer",
  "header": "wNpI9W_header",
  "modalBody": "wNpI9W_modalBody",
  "modalContent": "wNpI9W_modalContent",
  "root": "wNpI9W_root",
  "title": "wNpI9W_title",
  "titleContainer": "wNpI9W_titleContainer",
});
